<selection-lists [resourceType]="resourceType"
                 class="d-block pt-3 pb-5">
</selection-lists>
